import styled from 'styled-components';

const ListContainer = styled.article`
	.tab-panel__data {
		padding: 0px;
	}
`;

export default ListContainer;
